<template>
  <div v-if="!authChecking">
    <NavBar v-if="isAuthenticated" />
    <router-view />
  </div>
  <div v-else>
    Checking session...
  </div>
</template>

<script>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import NavBar from "./components/NavBar.vue";

export default {
  name: "App",
  components: {
    NavBar
  },
  setup() {
    const store = useStore();
    const authChecking = computed(() => store.state.authChecking);
    const isAuthenticated = computed(() => !!store.state.user);
    
    onMounted(async () => {
      await store.dispatch("checkAuth");
    });
    return { authChecking, isAuthenticated };
  },
};
</script>


